import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface SkeletonProps {
  className?: string;
  variant?: 'rectangular' | 'circular' | 'text';
}

const Skeleton: React.FC<SkeletonProps> = ({ className = '', variant = 'rectangular' }) => {
  const { actualTheme } = useTheme();
  
  const baseClasses = "animate-pulse rounded-lg";
  const themeClasses = actualTheme === 'dark' 
    ? "bg-slate-800/50" 
    : "bg-slate-200/50";
    
  const variantClasses = {
    rectangular: "",
    circular: "rounded-full",
    text: "h-4 w-3/4 mb-2"
  }[variant];

  return (
    <div className={`${baseClasses} ${themeClasses} ${variantClasses} ${className}`} />
  );
};

export const TourCardSkeleton: React.FC = () => {
  const { actualTheme } = useTheme();
  return (
    <div className={`rounded-2xl overflow-hidden border ${actualTheme === 'dark' ? 'bg-slate-800/30 border-slate-700/50' : 'bg-white border-neutral-200/50'} shadow-sm`}>
      <Skeleton className="h-48 sm:h-56 md:h-64 w-full rounded-none" />
      <div className="p-4 sm:p-5 md:p-6 space-y-4">
        <div className="space-y-2">
          <Skeleton variant="text" className="w-1/2" />
          <Skeleton variant="text" className="w-full h-6" />
        </div>
        <div className="flex gap-4">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-20" />
        </div>
        <div className="space-y-2 pt-2">
          <Skeleton variant="text" className="w-1/3 h-8" />
        </div>
        <div className="flex gap-2 pt-2">
          <Skeleton className="h-8 w-24 rounded-full" />
          <Skeleton className="h-8 w-24 rounded-full" />
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
